import { get, post, patch, destroy } from '../utils/api';

export const getMemoir = id => get(`/v3/memoirs/${id}`);
export const postMemoir = body => post(`/v3/memoirs`, body);
export const patchMemoir = body => patch(`/v3/memoirs/${body.id}`, { data: { attributes: body } });
export const destroyMemoir = id => destroy(`/v3/memoirs/${id}`);

export const copyStoryToMemoir = (memoirId, storyId) => post(`/v3/memoirs/${memoirId}/copy_story/${storyId}`);
